import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable()
export abstract class HttpService {
  http: HttpClient;
  constructor(http: HttpClient) {
    this.http = http;
  }

  getToken(_url, _key): Observable<any> {
    return this.http.post<{ bearerToken: string }>(_url + "/authenticate", {
      key: _key,
    });
  }
}
